<template>
    <article class="main-store">
        <div class="store-tit">
            <p class="">오시는 길</p>
        </div>

        <!-- 네이버 지도  -->
        <naver-map
            class="store-map"
            id="store-location-map"
            :mapOptions="mapOptions"
            :initLayers="initLayers"
            @onLoad="onLoadMap($event)"
            :key="mapKey"
        />

        <!-- 점포 정보 -->
        <address class="store-info">
            <p class="info-adr">
                {{ storeInfo.address }}<br />
                {{ storeInfo.storeName }}
            </p>
            <div class="info-con">
                <strong>대표번호</strong>
                <span>{{ storeInfo.telNo }}</span>
            </div>
            <div class="info-con">
                <strong>영업시간</strong>
                <span>{{ storeInfo.openingHours }}</span>
            </div>
        </address>
    </article>
</template>

<script setup>
    import { toRefs, computed, ref, watch } from 'vue';
    import { useRootStore } from '@/stores/modules';
    import { NaverMap } from 'vue3-naver-maps';

    const rootStore = useRootStore();
    const { storeLatLng, storeInfo } = toRefs(rootStore);

    const initLayers = ['BACKGROUND', 'BACKGROUND_DETAIL', 'POI_KOREAN', 'TRANSIT'];

    const mapOptions = computed(() => ({
        latitude: storeLatLng.value.lat,
        longitude: storeLatLng.value.lng,
        zoom: 17,
    }));

    const mapInstance = ref(null);
    const mapKey = ref(0); // naver-map 컴포넌트를 재생성하기 위한 용도

    const onLoadMap = (mapObject) => {
        mapInstance.value = mapObject;
    };

    watch(storeInfo, (to) => {
        if (to) {
            // 변경시 지도를 새로 그림
            mapKey.value += 1;
        }
    });
</script>
